<template>
  <div>
    <!-- fil d'ariane-->
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-lg-10">
        <h2>Cessions</h2>
        <ol class="breadcrumb">
          <li>
            <a href="index.html">Accueil</a>
          </li>
          <li class="active">
            <strong>Cessions</strong>
          </li>
        </ol>
      </div>
      <div class="col-lg-2"></div>
    </div>
    <!-- end fil d'ariane -->
    <div class="wrapper wrapper-content animated fadeInRight">
      <!-- instruction -->
      <Accordion title="Instructions" titleIcon="fa fa-book" :expandedProp="false">
        <template slot="content">
          <div class="row m-b-md">
            <div class="col-lg-2">
              <i class="fa fa-circle text-warning"></i>
              <span>  En préparation </span>
            </div>
            <div class="col-lg-10">
              <b>Carizy a encore des documents et informations à récupérer</b> de la part des clients pour compléter le dossier de vente
            </div>
          </div>
          <div class="row m-b-md">
            <div class="col-lg-2">
              <i class="fa fa-circle text-success"></i>
              <span>  A réaliser</span>
            </div>
            <div class="col-lg-10">
              <b>Le dossier de vente des clients est complet</b> pour le rendez-vous de cession. Vous pouvez imprimer les documents.
            </div>
          </div>
          <div class="row m-b-md">
            <div class="col-lg-2">
              <i class="fa fa-circle text-navy"></i>
              <span>  En cours de finalisation</span>
            </div>
            <div class="col-lg-10">
              Le véhicule a été vendu.
              <b>Vérifiez que vous avez bien posté les documents à Carizy</b>. Le rendez-vous passera en « Cession finalisée » lorsque nous aurons reçu tous les documents.
            </div>
          </div>
          <p class="text-center m-t-md">
            <small>
              Un doute sur l’organisation d’un rendez-vous de cession ?
              <a
                href="urldelafichepratique"
              >Consultez notre fiche pratique (en pdf)</a>
            </small>
          </p>
        </template>
      </Accordion>
      <!-- fin instruction -->
      <!-- barre de recherche -->
      <Accordion title="Rechercher" titleIcon="fa fa-search" :searchBarClassProp="true" :expandedProp="true">
        <template slot="content">
          <div class="row">
            <div class="col-lg-2">
              <div class="form-group input-bottom">
                <label class="control-label " for="reportrange">
                  <div id="reportrange" class="form-control label-calendar">
                    <i class="fa fa-calendar"></i>
                    <span>Début - Fin</span> <b class="caret"></b>
                  </div>
                </label>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="form-group input-bottom">
                <label class="control-label">
                  <select
                    name="status"
                    class="form-control border-none"
                    v-model="filters.status"
                  >
                    <option :value="null">Statut</option>
                    <option
                      v-for="(item, index) in getOrderStatusList"
                      :key="index"
                      :value="item.id"
                    >
                      {{ item.label }}
                    </option>
                  </select>
                </label>
              </div>
            </div>
            <template v-if="isAdministrator">
              <div class="col-lg-2">
                <div class="form-group input-bottom">
                  <label class="control-label">
                    <select
                      name="expertiseCompanies"
                      class="form-control border-none"
                      v-model="filters.expert"
                    >
                      <option :value="null">{{ companyTypeLabel }}</option>
                      <option
                        v-for="company in expert"
                        :key="company.id"
                        :value="company.id"
                      >
                        {{ company.name }}
                      </option>
                    </select>
                  </label>
                </div>
              </div>
            </template>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label" for="search">
                  <input
                    type="text"
                    id="search"
                    name="search"
                    placeholder="Rechercher"
                    class="form-control"
                    v-model="filters.search"
                  />
                </label>
              </div>
            </div>
          </div>
        </template>
      </Accordion>
      <!-- fin barre de recherche -->

      <!-- tableau liste des commandes -->
      <div class="row" :class="{ 'sk-loading': $apollo.queries.orderList.loading}">
        <div class="col-lg-12 mb20" v-if="$apollo.queries.orderList.loading">
          <spinner-three-bounce :displayNone="!$apollo.queries.orderList.loading"/>
          <div class="centerText">
            <h3>Veuillez patienter pendant le chargement de vos données.</h3>
            <p>Relaxez-vous et prenez une grande inspiration.</p>
          </div>
        </div>
        <div class="col-lg-12" v-if="!$apollo.queries.orderList.loading">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5><i class="fa fa-list"></i> Liste des rendez-vous de cession</h5>
              <div class="ibox-tools">
                <a class="collapse-link">
                  <i class="fa fa-chevron-up"></i>
                </a>
              </div>
            </div>
            <div class="ibox-content">
              <div class="row">
                <div class="col-lg-8"/>
                <div class="col-lg-4">
                  <small class="pull-right input-bottom">
                    <label class="control-label label-per-page"><span>Par page</span>
                      <select
                        name="perPage"
                        class="form-control select-per-page"
                        v-model="filters.per_page"
                      >
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                        <option :value="200">200</option>
                      </select>
                    </label>
                  </small>
                </div>
              </div>
              <div class="table-responsive m-t">
                <table v-show="orderList.length" class="table table-order table-hover table-striped dataTables-example">
                  <thead>
                    <tr>
                      <th>#</th>
                      <template v-if="isAdministrator">
                        <th class="w-150">{{ companyTypeLabel }}</th>
                      </template>
                      <th>Organisation</th>
                      <th class="w-150">Vendeur</th>
                      <th class="w-150">Acheteur</th>
                      <th class="w-150">Véhicule</th>
                      <th class="w-100 text-center">RDV </th>
                      <th class="w-150 text-center">Lieu RDV</th>
                      <th class="w-100">Statut</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in orderList" :key="index">
                      <template v-if="item.saleRdv">
                        <td>{{ item.id }}</td>
                        <template v-if="isAdministrator">
                          <td>{{ item.saleRdvExpert ? item.saleRdvExpert.name : '' }}</td>
                        </template>
                        <td>{{ item.realm | capitalize }}</td>
                        <td>
                          <span>{{ getSeller(item).firstname + ' ' + getSeller(item).lastname }}</span>
                          <small class="text-muted">
                            <br>{{ getSeller(item).phone }} <i class="fa fa-copy"></i>
                            <br>{{ getSeller(item).email }} <i class="fa fa-copy"></i>
                          </small>
                        </td>
                        <td>
                          <span>{{ getBuyer(item).firstname + ' ' + getBuyer(item).lastname }}</span>
                          <small class="text-muted">
                            <br>{{ getBuyer(item).phone }} <i class="fa fa-copy"></i>
                            <br>{{ getBuyer(item).email }} <i class="fa fa-copy"></i>
                          </small>
                        </td>
                        <td>
                          <a :href="getVehicleUrl(item)" target="_blank">{{ getVehicle(item).make + ' ' + getVehicle(item).model}}</a>
                        </td>
                        <td class="text-center">
                          <template v-if="item.saleRdv">
                            <span class="pull-right"></span>
                            <span class="rdvcession">
                              {{ item.saleRdv[0].date | formatDateTime }}
                            </span>
                          </template>
                        </td>
                        <td class="text-center">
                          <template v-if="item.saleRdv">
                            <span class="pull-right"></span>
                            <span class="rdvcession">
                              {{ item.saleRdv[0].address.address }}
                              {{ item.saleRdv[0].address.zipCode }}
                              {{ item.saleRdv[0].address.city }}
                            </span>
                          </template>
                        </td>
                        <td>
                          <small>
                            <component-status :status="item.status"></component-status>
                          </small>
                        </td>
                        <td class="text-center">
                          <button type="button" class="btn btn-xs btn-success">
                            <small>
                              <router-link  :to="'/cession/' + item.id">
                                <i class="fa fa-eye"></i>&nbsp;<span>voir</span>
                              </router-link>
                            </small>
                          </button>
                        </td>
                      </template>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td :colspan="isAdministrator ? 9 : 8" class="text-center">
                        <component-pagination v-if="totalPages" v-model="filters.page" :total-pages="totalPages"/>
                      </td>
                    </tr>
                  </tfoot>
                </table>
                <div v-if="!$apollo.loading && !orderList.length">
                  Aucune commande n'a été trouvée.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag"
import NProgress from "nprogress"
import store from "../config/store"
import CommercialList from "../api/query/CommercialList.gql"
import PartnerList from "../api/query/PartnerList.gql"
import StatusOptionList from '../api/query/StatusOptionList.gql'
import Pagination from "../components/Pagination.vue"
import Status from "@/components/details/Status.vue"
import SpinnerThreeBounce from '@/components/spinners/SpinnerThreeBounce'
import moment from 'moment'
import Accordion from '@/components/accordion/accordion'

export default {

   components: {
      'component-pagination': Pagination,
      'component-status': Status,
      SpinnerThreeBounce,
      Accordion
    },

    data: () => ({
      store,
      orderList: [],
      accountManager: [],
      expert: [],
      dashboardKpis: null,
      pageChanged: true,
      kpiPeriod: 'month',
      filters: {
        page: 1,
        per_page: 50,
        search: '',
        dateMin: null,
        dateMax: null,
        status: null,
        commercial: null,
        delivery: null,
        options: null,
        partner: null,
        expert: null,
      },
      selectedItemId: null
    }),

    computed: {
      isAdministrator() {
        return store.data.userInfos.userIsManager;
      },
      companyTypeLabel() {
        if (this.expert.length > 0) {
          if (this.expert[0].type === 'bca') {
            return 'Agence';
          }
        }
        return 'Cabinet';
      },
      filtersList () {
        return JSON.stringify(this.filters)
      },
      totalPages () {
        if (!this.orderList.length) {
          return 0
        }
        return parseInt(this.orderList[0].pageInfo.totalPages)
      },
    },

    watch: {
      'filtersList': function (newValue, oldValue) {
        if (JSON.parse(newValue).page === JSON.parse(oldValue).page) {
          this.pageChanged = false
        } else {
          this.pageChanged = true
          window.scrollTo(0, 0)
        }
      },
      '$apollo.loading': function () {
        if (!this.$apollo.loading) {
          store.loading = false
          NProgress.done()
        }
      }
    },

    mounted () {
      store.loading = true

      $('#reportrange').daterangepicker({
        format: 'DD/MM/YYYY',
        locale: {
          applyLabel: 'Valider',
          cancelLabel: 'Annuler',
          fromLabel: 'Début',
          toLabel: 'Fin',
          daysOfWeek: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
          monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Décembre"],
          firstDay: 1
        }
      }, (start, end) => {
        this.filters.dateMin = start.format('YYYY-MM-DD')
        this.filters.dateMax = end.format('YYYY-MM-DD')

        moment.locale('fr')
        let formattedStart = moment(this.filters.dateMin, 'YYYY-MM-DD').format('DD MMMM YYYY')
        let formattedEnd = moment(this.filters.dateMax, 'YYYY-MM-DD').format('DD MMMM YYYY')
        $('#reportrange span').html(formattedStart + ' - ' + formattedEnd);
      });

      this.$bus.$on('delete-confirm-success', this.onDeleteOrderConfirm)
    },
   methods: {
     getVehicleUrl (item) {
       let domain = null

       if (item.realm === "renault") {
         domain = process.env.VUE_APP_REP_DOMAIN
       } else {
         domain = process.env.VUE_APP_FRONTOFFICE_DOMAIN
       }

       return domain + this.getVehicle(item).url
     },

      commandListQuery () {
        let queries = []

        queries.push('statusList: [' + Status.constants.TO_PREPARE +', ' + Status.constants.TO_DO + ']')

        if (!this.pageChanged) {
          this.filters.page = 1
        }
        for (let key in this.filters) {
          if (this.filters[key] || typeof this.filters[key] === typeof true) {
            if ('expertiseCompany' == key) {
              queries.push(key + ': [' + this.filters[key] + ']')
            } else if ('status' == key) {
              let statusValues = [this.filters[key]];

              queries[0] = 'statusList: [' + statusValues.join(', ') + ']'
            } else if (['search', 'commercial', 'dateMin', 'dateMax'].includes(key)) {
              queries.push(key + ': "' + this.filters[key] + '"')
            } else {
              queries.push(key + ': ' + this.filters[key])
            }
          }
        }
        return gql`
          { orderList (${queries.join(', ')}) {
            id
            realm
            status {
              id
              label
            }
            delivery
            commercial {
              id
              firstname
              lastname
            }
            options {
              name
            }
            seller {
              id
              firstname
              lastname
              email
              phone
          address{
              address
              zipCode
              city
              }
            }
            buyer {
              firstname
              lastname
              email
              phone
              address{
              address
              zipCode
              city
              }
            }
            vehicule {
              id
              make
              model
              version
              color
              fuel
              licensePlate
              url
            }
            saleRdv {
              id
              address{
              address
              zipCode
              city
              }
              date
              status
            }
            saleRdvExpert {
              id
              name
            }
            pageInfo {
              totalPages
            }
          }
          }
        `
      },

      getSeller (item) {
        return item.seller[0]
      },
      getBuyer (item) {
        return item.buyer[0]
      },
      getVehicle (item) {
        return item.vehicule[0]
      },
      isCommandCancelled (item) {
        return item.status.id === Status.constants.CANCELLED
      },
      isCommandFinished (item) {
        return item.status.id === Status.constants.SOLD
      },
    },

    apollo: {
      accountManager: {
        query: CommercialList
      },
      getOrderStatusList: {
        query: StatusOptionList
      },
      orderList: {
        query () {
          return this.commandListQuery()
        },
        result ({ data, loading, networkStatus }) {
          setTimeout(function(){ 
            if ( $.fn.dataTable.isDataTable( '.dataTables-example' ) ) {
              $('.dataTables-example').DataTable();
            } else {
              $('.dataTables-example').DataTable({
                "retrieve": true,
                "paging": false,
                "info": false,
                "searching": false,
                "order": [[ 0, "desc" ]]
              });
            }
          }, 3000);          
        },
      },
    }
}
</script>
